import PortalAppService from "../../../application/platform/portal-app-service";
import { usePncpPurchaseContractDetailDispatch } from "./pncp-purchase-contract-detail-context";
import { ACTION_TYPES } from "./pncp-purchase-contract-detail-reducer";

export const usePncpPurchaseContractDetailController = () => {
    const dispatch = usePncpPurchaseContractDetailDispatch();

    const loadContractDetail = async (id: number) => {
        dispatch({ type: ACTION_TYPES.LOAD_START });
        try {
            const contractDetail = await PortalAppService.getPncpPurchaseContractDetail(id);
            dispatch({ type: ACTION_TYPES.LOAD_SUCCESS, payload: contractDetail });
        } catch (error: any) {
            dispatch({ type: ACTION_TYPES.LOAD_ERROR, payload: error?.response?.data?.message || 'Erro ao carregar detalhes do contrato' });
        }
    };

    return { loadContractDetail };
};
